import { render, staticRenderFns } from "./ForestPlot.vue?vue&type=template&id=1a81cdd4"
import script from "./ForestPlot.vue?vue&type=script&lang=js"
export * from "./ForestPlot.vue?vue&type=script&lang=js"
import style0 from "./ForestPlot.vue?vue&type=style&index=0&id=1a81cdd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports